import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import UIAssetKeys from '../UIAssetKeys';

export default class StackPlaceHolder extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     * @param {number} x 
     * @param {number} y 
     */
    constructor(scene, x, y, placeVal, color)
    {
        super(scene, x, y);

        this.scene.add.existing(this);

        this.placeVal = placeVal;
        this.fadedCup = ABCyaPhaser.Images.addImage(0, 0, 'game-items/cup-' + color + '_0', this).setAlpha(0.2).setScale(1.2).setTintFill(0x000000);
        this.outlineDisplay = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._game_items_cup_outline_0, this);
        this.placeLabel = ABCyaPhaser.Text.addText(0, 6, 72, gameData.UNREADY_COLOR, FontKeys._odin_roundedregular, placeVal.toString().toUpperCase(), this).setOrigin(0.5).setStroke(0x000000, 4);
    }

    showReadyInOutline(isReady)
    {
        this.placeLabel.setColor(Phaser.Display.Color.IntegerToColor((isReady) ? gameData.READY_COLOR : gameData.UNREADY_COLOR).rgba);
        this.placeLabel.alpha = (isReady) ? 1 : 0.35;
    }
}